<div fxLayout="column" class="audio-player-container">
	<div class="audio-player" fxLayout="column" fxLayoutAlign="start stretch">
		<loader [loader]="loader" [type]="'general'"></loader>
		<div class="audio-block" fxFlex="1 1" fxLayoutAlign="start stretch">
			<div id="waveform"></div>
			<audio>
				<!-- <source src="http://grochtdreis.de/fuer-jsfiddle/audio/sintel_trailer-480.mp4" type="audio/mp4"> -->
			</audio>
		</div>
		<div class="controller" fxLayout="column" fxLayoutAlign="start stretch">
			<div class="control-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="0px">
				<div class="controls" fxLayout="row" fxLayoutAlign="space-between center">
					<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" fxLayoutGap.xs="10px">
						<ng-container *ngIf="wave?.getDuration() !== wave?.getCurrentTime() && !disableForward">
							<button mat-icon-button class="icon-play" type="button" (click)="tooglePlay()" [disabled]="!canStartPlay">
								<mat-icon>
									{{(isPlaying) ? 'pause' : 'play_arrow'}}
								</mat-icon>
							</button>
						</ng-container>

						<ng-container *ngIf="disableForward">
							<button mat-icon-button class="icon-play" type="button" (click)="replay()">
								<mat-icon>
									replay
								</mat-icon>
							</button>
						</ng-container>

						<div fxLayoutAlign="start center">
							<ng-container *ngIf="totalDuration">
								<p class="time">{{audioDuration}} / {{totalDuration}}</p>
							</ng-container>
						</div>
						<ng-container *ngIf="options?.skip">
							<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0px">
								<button mat-icon-button [disabled]="wave?.getCurrentTime() === 0 || !canStartPlay" type="button"
									(click)="backward()" matTooltip="-10s" matTooltipPosition="above">
									<mat-icon svgIcon="rewind"></mat-icon>
								</button>
								<button mat-icon-button [disabled]="disableForward || !canStartPlay" type="button" (click)="forward()"
									matTooltip="+10s" matTooltipPosition="above">
									<mat-icon svgIcon="forward"></mat-icon>
								</button>
							</div>
						</ng-container>
					</div>

					<ng-container
						*ngIf="bookMarksData?.length && showBookmarkPagination && bookMarksData[currentBookmarkIndex]?.timelineData?.length">
						<div fxFlex="0 0 auto" fxFlex.xs="1 1" class="active-bookmark" fxLayout="row" fxLayoutAlign="start center"
							fxLayoutGap="0px">
							<div fxFlex="0 0 auto">
								<button type="button" mat-icon-button [disabled]="currentTimelineIndex === 0"
									(click)="changeBookmark('before')">
									<mat-icon>arrow_back_ios</mat-icon>
								</button>
							</div>
							<app-chips fxFlex="0 0 auto" fxFlex.xs="1 1" class="active-grand-chip" type="grand" [removable]="true"
								(removed)="removeBookMarkSelection($event)"
								[data]="{title: bookMarksData[currentBookmarkIndex]?.caption}">
							</app-chips>
							<div fxFlex="0 0 auto">
								<button type="button" mat-icon-button
									[disabled]="currentTimelineIndex === (bookMarksData[currentBookmarkIndex]?.timelineData?.length - 1)"
									(click)="changeBookmark('after')">
									<mat-icon>arrow_forward_ios</mat-icon>
								</button>
							</div>
						</div>
					</ng-container>

					<div
						[ngStyle]="{'display': detectDevice?.resolutionState$?.value?.deviceType === 'mobile' ? 'none' : 'block'}"
						fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0px" class="additional-controls">
						<div class="controls-items volume-control" (mouseover)="onVolumeMouseOver($event)"
							(mouseleave)="onVolumeMouseLeave($event)">
							<button mat-icon-button type="button" (click)="mute()" [disabled]="!canStartPlay">
								<mat-icon>{{(wave?.getMute()) ? 'volume_off' : 'volume_up'}}</mat-icon>
							</button>
							<div class="ranger" fxLayoutAlign="center center" #volumeControlEl>
								<div class="volume-bar" #volumeBarEl (mousedown)="volumeControl($event)">
									<div class="volume-progress" #volumeProgressEl></div>
								</div>
								<div class="progress-pointer" #volumePointerEl draggable="true"
									(mousedown)="volumePointerMouseDown($event)"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<ng-container *ngIf="bookMarksData?.length">
				<div class="expansion-views" fxLayout="row" fxLayoutAlign="space-between start">
					<div class="feature-list" fxLayout="row wrap" fxLayoutAlign="start start" fxLayoutGap="0px" #bookmarkEl>
						<ng-container *ngFor="let bookmark of bookMarksData; let i = index">
							<!-- <div (click)="currentBookmarkIndex = i; showBookmarkPagination = true;setBookmarkTime(bookmark.timelineData[0]); currentTimelineIndex = 0;"> -->
							<app-chips type="grand" class="feature-item" [data]="{title: bookmark?.caption}"
								(chipInfo)="currentBookmarkIndex = i; showBookmarkPagination = true;setBookmarkTime(bookmark.timelineData[0]); currentTimelineIndex = 0;">
							</app-chips>
							<!-- </div> -->
						</ng-container>
					</div>
					<ng-container *ngIf="showExtraBookmark">
						<button mat-icon-button (click)="showMoreBookmarks()" [disabled]="!canStartPlay">
							<mat-icon class="icon-drop">{{ (expanded) ? 'arrow_drop_up' : 'arrow_drop_down'}}</mat-icon>
						</button>
					</ng-container>
				</div>
			</ng-container>
		</div>
	</div>
</div>
